<template>
  <div class="mb-4 border rounded p-3">
    <h5>{{ title }}</h5>
    <div class="form-group row align-items-center mb-3">
      <label class="col-lg-2">{{ selectedLabel }}</label>
      <div class="col-lg-6">
        <select class="form-control" :value="selectedId" @change="$emit('select', $event.target.value)">
          <option value="">—</option>
          <option v-for="item in items" :key="itemId(item)" :value="itemId(item)">{{ labelFor(item) }}</option>
        </select>
      </div>
    </div>
    <table v-if="items.length" class="table table-sm mb-3">
      <thead>
        <tr>
          <th>نام</th>
          <th v-if="showGender">جنسیت</th>
          <th>عملیات</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="itemId(item)">
          <td>{{ labelFor(item) }}</td>
          <td v-if="showGender">{{ genderLabel(item) }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-gradient-03 mr-2" @click="$emit('select', itemId(item))">
              انتخاب
            </button>
            <button type="button" class="btn btn-sm btn-gradient-01" @click="$emit('remove', itemId(item))">حذف</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="form-group row align-items-center">
      <label class="col-lg-2">افزودن</label>
      <div class="col-lg-6">
        <select class="form-control" v-model="pickId">
          <option value="">انتخاب کنید</option>
          <option v-for="opt in options" :key="itemId(opt)" :value="itemId(opt)">{{ labelFor(opt) }}</option>
        </select>
      </div>
      <div class="col-lg-2">
        <button type="button" class="btn btn-success" :disabled="!pickId" @click="onAdd">افزودن</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FakeBotAssetSection',
  props: {
    title: String,
    items: { type: Array, default: () => [] },
    selectedId: String,
    options: { type: Array, default: () => [] },
    selectedLabel: String,
    labelFor: { type: Function, required: true },
    showGender: { type: Boolean, default: false },
    genderFor: { type: Function, default: null },
  },
  data() {
    return { pickId: '' };
  },
  methods: {
    itemId(item) {
      return item && item._id ? item._id : item;
    },
    genderLabel(item) {
      if (this.genderFor) return this.genderFor(item);
      return item.isGirl ? 'دخترونه' : 'پسرونه';
    },
    onAdd() {
      this.$emit('add', this.pickId);
      this.pickId = '';
    },
  },
};
</script>
